import { TranslationMessages } from "react-admin";
import englishMessages from "ra-language-english";

const customEnglishMessages: TranslationMessages = {
  ...englishMessages,

  developing: "This feature is currently under development",
  "development in progress": "Development in progress",
  undefined: "Undefined",
  pos: {
    search: "Search",
    configuration: "Configuration",
    language: "Language",
    theme: {
      name: "Theme",
      light: "Light",
      dark: "Dark",
    },
    dashboard: {
      monthly_revenue: "Monthly Revenue",
      month_history: "30 Day Revenue History",
      new_orders: "New Orders",
      pending_reviews: "Pending Reviews",
      all_reviews: "See all reviews",
      new_customers: "New Customers",
      all_customers: "See all customers",
      pending_orders: "Pending Orders",
      order: {
        items:
          "by %{customer_name}, one item |||| by %{customer_name}, %{nb_items} items",
      },
      welcome: {
        title: "Welcome to  Happy Mango!",
        subtitle:
          "To help you hit the ground running with testing, we added one testing product and used mock data to complete your institution profile. However, you can customize your account at any time.  Below are the key areas you can start customizing your account.",
        add_products_button: "Add your products",
        add_team_button: "Add your team members",
        update_bank_button: "Update your organizational profile",
      },
    },
    menu: {
      sales: "Sales",
      catalog: "Catalog",
      customers: "Customers",
      applications: "Applications",
    },
    events: {
      review: {
        title: 'Posted review on "%{product}"',
      },
      order: {
        title: "Ordered 1 poster |||| Ordered %{smart_count} posters",
      },
    },
  },
  hm: {
    dashboard: {
      welcome: {
        title: "Welcome to  Happy Mango!",
        subtitle:
          "To help you hit the ground running with testing, we added one testing product and used mock data to complete your institution profile. However, you can customize your account at any time.  Below are the key areas you can start customizing your account.",
        add_products_button: "Add your products",
        add_team_button: "Add your team members",
        update_bank_button: "Update your organizational profile",
      },
    },
    menu: {
      banks: "Institution",
      bankers: "Bankers",
      applications: "Applications",
      loans: "Loans",
    },
  },
  ra: {
    ...englishMessages.ra,
    action: {
      ...englishMessages.ra.action,
      add_filter: "Filter",
    },
  },
  resources: {
    customers: {
      name: "Customer |||| Customers",
      fields: {
        commands: "Orders",
        first_seen: "First seen",
        groups: "Segments",
        last_seen: "Last seen",
        last_seen_gte: "Visited Since",
        name: "Name",
        total_spent: "Total spent",
        password: "Password",
        confirm_password: "Confirm password",
        stateAbbr: "State",
      },
      filters: {
        last_visited: "Last visited",
        today: "Today",
        this_week: "This week",
        last_week: "Last week",
        this_month: "This month",
        last_month: "Last month",
        earlier: "Earlier",
        has_ordered: "Has ordered",
        has_newsletter: "Has newsletter",
        group: "Segment",
      },
      fieldGroups: {
        identity: "Identity",
        address: "Address",
        stats: "Stats",
        history: "History",
        password: "Password",
        change_password: "Change Password",
      },
      page: {
        delete: "Delete Customer",
      },
      errors: {
        password_mismatch:
          "The password confirmation is not the same as the password.",
      },
    },
    commands: {
      name: "Order |||| Orders",
      amount: "1 order |||| %{smart_count} orders",
      title: "Order %{reference}",
      fields: {
        basket: {
          delivery: "Delivery",
          reference: "Reference",
          quantity: "Quantity",
          sum: "Sum",
          tax_rate: "Tax Rate",
          taxes: "Tax",
          total: "Total",
          unit_price: "Unit Price",
        },
        address: "Address",
        customer_id: "Customer",
        date_gte: "Passed Since",
        date_lte: "Passed Before",
        nb_items: "Nb Items",
        total_gte: "Min amount",
        status: "Status",
        returned: "Returned",
      },
      section: {
        order: "Order",
        customer: "Customer",
        shipping_address: "Shipping Address",
        items: "Items",
        total: "Totals",
      },
    },
    invoices: {
      name: "Invoice |||| Invoices",
      fields: {
        date: "Invoice date",
        customer_id: "Customer",
        command_id: "Order",
        date_gte: "Passed Since",
        date_lte: "Passed Before",
        total_gte: "Min amount",
        address: "Address",
      },
    },
    products: {
      name: "Poster |||| Posters",
      fields: {
        category_id: "Category",
        height_gte: "Min height",
        height_lte: "Max height",
        height: "Height",
        image: "Image",
        price: "Price",
        reference: "Reference",
        sales: "Sales",
        stock_lte: "Low Stock",
        stock: "Stock",
        thumbnail: "Thumbnail",
        width_gte: "Min width",
        width_lte: "Max width",
        width: "Width",
      },
      tabs: {
        image: "Image",
        details: "Details",
        description: "Description",
        reviews: "Reviews",
      },
      filters: {
        categories: "Categories",
        stock: "Stock",
        no_stock: "Out of stock",
        low_stock: "1 - 9 items",
        average_stock: "10 - 49 items",
        enough_stock: "50 items & more",
        sales: "Sales",
        best_sellers: "Best sellers",
        average_sellers: "Average",
        low_sellers: "Low",
        never_sold: "Never sold",
      },
    },
    categories: {
      name: "Category |||| Categories",
      fields: {
        products: "Products",
      },
    },
    reviews: {
      name: "Review |||| Reviews",
      amount: "1 review |||| %{smart_count} reviews",
      relative_to_poster: "Review on poster",
      detail: "Review detail",
      fields: {
        customer_id: "Customer",
        command_id: "Order",
        product_id: "Product",
        date_gte: "Posted since",
        date_lte: "Posted before",
        date: "Date",
        comment: "Comment",
        rating: "Rating",
      },
      action: {
        accept: "Accept",
        reject: "Reject",
      },
      notification: {
        approved_success: "Review approved",
        approved_error: "Error: Review not approved",
        rejected_success: "Review rejected",
        rejected_error: "Error: Review not rejected",
      },
    },
    segments: {
      name: "Segment |||| Segments",
      fields: {
        customers: "Customers",
        name: "Name",
      },
      data: {
        compulsive: "Compulsive",
        collector: "Collector",
        ordered_once: "Ordered once",
        regular: "Regular",
        returns: "Returns",
        reviewer: "Reviewer",
      },
    },

    /* b2b menu */
    applications: {
      name: "Application |||| Applications",
      fields: {
        name: "Name",
        description: "Description",
        status: "Status",
        created_at: "Created At",
        updated_at: "Updated At",
      },
      tabs: {
        details: "Details",
        description: "Description",
      },
      filters: {
        status: "Status",
        active: "Active",
        inactive: "Inactive",
      },
      submenu: {
        check: "New",
        hold: "Hold",
        initiate: "To Initiate Review",
        review: "To Finalize Review",
        execute: "To Notify Applications",
        approved: "Approved",
        countered: "Countered",
        declined: "Declined",
        preapproved: "Pre-Approved",
        incomplete: "Incomplete",
        expired: "Expired",
      },
    },
    loans: {
      name: "Loan |||| Loans",
      fields: {
        application_id: "Application",
        status: "Status",
        created_at: "Created At",
        updated_at: "Updated At",
      },
      tabs: {
        details: "Details",
        description: "Description",
      },
      filters: {
        status: "Status",
        active: "Active",
        inactive: "Inactive",
      },
      submenu: {
        active: "Active",
        paidoff: "Paid-Off",
        chargedoff: "Charged-Off",
        voided: "Voided",
      },
    },
    reports: {
      name: "Report |||| Reports",
      fields: {
        name: "Name",
        description: "Description",
        status: "Status",
        created_at: "Created At",
        updated_at: "Updated At",
      },
      tabs: {
        details: "Details",
        description: "Description",
      },
      filters: {
        status: "Status",
        active: "Active",
        inactive: "Inactive",
      },
      submenu: {
        annual: "Annual Reports",
        monthly: "Monthly Reports",
        daily: "Daily Reports",
        realtime: "Real-TIme Charts",
        dataquery: "Data Query",
        dataupload: "Data Upload",
      },
    },
    admins: {
      name: "Admin |||| Admins",
      fields: {
        name: "Name",
        description: "Description",
        status: "Status",
        created_at: "Created At",
        updated_at: "Updated At",
      },
      tabs: {
        details: "Details",
        description: "Description",
      },
      filters: {
        status: "Status",
        active: "Active",
        inactive: "Inactive",
      },
      submenu: {
        institution: "Institution",
        team: "Team",
        products: "Products",
        documents: "Documents",
        alerts: "Alerts",
        payments: "Payments",
        partners: "Partners",
        transunion: "Credit Report",
        campaigns: "Campaigns",
      },
    },

    /* end b2b menu */
  },
};

export default customEnglishMessages;
